<header class="sticky top-0 z-50 border-b border-gray-200 bg-brand-header backdrop-blur">
  <div class="mx-auto flex h-20 max-w-7xl items-center justify-between px-6">

    <a routerLink="/" class="flex items-center gap-1 transition hover:opacity-90" aria-label="Company Home">
      <img
        [src]="branding().logoUrl"
        [alt]="branding().logoAlt"
        class="h-10 w-auto object-contain"
      />
      <span class="hidden text-lg font-bold text-gray-900 sm:block">
        {{ branding().companyName }}
      </span>
    </a>

    <div class="desktop-actions">

      <app-language-selector></app-language-selector>

    </div>
  </div>
</header>
